import { FC } from 'react';
import { IconContainer } from './Icon.styles';
import { IconProps } from './types';

export const Icon: FC<IconProps> = ({ icon, className, size = 'small', onClick, ...props }) => (
  <IconContainer className={className} size={size} onClick={onClick} {...props}>
    {icon}
  </IconContainer>
);
